module.exports = __webpack_public_path__ + "static/media/logo.60d3c325.svg";